/**
 * Utilitario de manipulacao de cores para o cardapio digital.
 * Centraliza as funcoes ajustarCor() e ajustarOpacidade() do componente principal.
 */

/**
 * Ajusta a luminosidade de uma cor hexadecimal.
 * @param hex - Cor em formato hexadecimal (ex: '#ffffff')
 * @param percentual - Valor positivo clareia, negativo escurece
 * @returns Cor ajustada em formato hexadecimal
 */
export function ajustarCor(hex: string, percentual: number): string {
  const cor = hex.replace('#', '');
  const num = parseInt(cor, 16);
  let r = (num >> 16) + percentual;
  let g = ((num >> 8) & 0x00FF) + percentual;
  let b = (num & 0x0000FF) + percentual;

  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

/**
 * Converte uma cor hexadecimal para rgba com opacidade especificada.
 * @param hex - Cor em formato hexadecimal (ex: '#0f172a')
 * @param opacidade - Valor de 0 a 1
 * @returns String rgba (ex: 'rgba(15, 23, 42, 0.65)')
 */
export function ajustarOpacidade(hex: string, opacidade: number): string {
  const cor = hex.replace('#', '');
  const num = parseInt(cor, 16);
  const r = (num >> 16) & 0xFF;
  const g = (num >> 8) & 0xFF;
  const b = num & 0xFF;
  return `rgba(${r}, ${g}, ${b}, ${opacidade})`;
}

/**
 * Verifica se uma cor hexadecimal e clara (luminosidade > 85%).
 * Usado para ajustar automaticamente surface/border quando o fundo e muito claro.
 */
export function corEhClara(hex: string): boolean {
  const cor = hex.replace('#', '');
  const num = parseInt(cor, 16);
  const r = (num >> 16) & 0xFF;
  const g = (num >> 8) & 0xFF;
  const b = num & 0xFF;
  const luminosidade = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminosidade > 0.85;
}
